// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11.0011 1.48999L1.81469 8.1643L11.0011 11.1491V1.48999Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M1.19604 10.0662L4.70517 20.8662L10.3831 13.0513L1.19604 10.0662Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M6.32406 22.0406H17.6781L12.0011 14.2268L6.32406 22.0406Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M19.2953 20.8638L22.8033 10.0671L13.6191 13.0513L19.2953 20.8638Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22.1857 8.16488L13.0011 1.49184V11.1491L22.1857 8.16488Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-radar-filled')
export default class ChartRadarFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-radar-filled',
    }
  }
}
